module.exports = __webpack_public_path__ + "static/media/semiTractorNoTrailer_gray.340ee6bb.svg";